const ShowPasswordIcon = ({ className = "", width = 25, height = 24, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {/* Eye icon path */}
      <path
        d="M12.5 5C7.5 5 3.73 8.11 2.5 12C3.73 15.89 7.5 19 12.5 19C17.5 19 21.27 15.89 22.5 12C21.27 8.11 17.5 5 12.5 5ZM12.5 17C9.74 17 7.5 14.76 7.5 12C7.5 9.24 9.74 7 12.5 7C15.26 7 17.5 9.24 17.5 12C17.5 14.76 15.26 17 12.5 17ZM12.5 9C11.12 9 10 10.12 10 12C10 13.88 11.12 15 12.5 15C13.88 15 15 13.88 15 12C15 10.12 13.88 9 12.5 9Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ShowPasswordIcon;
